// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-user-request-container {
  height: 100%;
}
.new-user-request-container .filter-section {
  background-color: var(--content-container-background);
  padding: 10px 10px 20px 10px;
  border-radius: 10px;
}
.new-user-request-container .filter-section .grid-container {
  padding: 0 5px;
}
.new-user-request-container .filter-section .filter-button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 100px;
  border-radius: 20px;
  padding: 5px;
}
.new-user-request-container .filter-section .filter-button .filter-label {
  font-weight: 600;
}
.new-user-request-container .filter-section .filter-label {
  font-size: 12px;
  font-weight: 400;
  font-family: "ABBVoice-regular";
}
.new-user-request-container .filter-section .filter-fields .css-13cymwt-control {
  width: 100% !important;
  min-height: 32px !important;
}
.new-user-request-container .filter-section .filter-fields .css-b62m3t-container {
  width: 90% !important;
}
.new-user-request-container .filter-section .filter-fields [role=option] {
  font-size: 12px !important;
}
.new-user-request-container .filter-section .input-width-90 {
  width: 90% !important;
}
.new-user-request-container .filter-section .apply-button {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}
.new-user-request-container .filter-section .ABB_CommonUX_Input__root > .ABB_CommonUX_Input__inputWrapper {
  height: 36px !important;
}
.new-user-request-container .gap-20 {
  gap: 20px;
}
.new-user-request-container .mt-20 {
  margin-top: 20px;
}
.new-user-request-container .action-link {
  color: #2934ff;
  cursor: pointer;
  font-family: "ABBvoice-regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}
.new-user-request-container .d-flex-justify-content-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
}
.new-user-request-container .css-j87k8z-control {
  width: 90% !important;
  min-height: 34px !important;
  border-color: #dbdbdb !important;
  border-radius: 4px !important;
  border-width: 2px !important;
}

input[type=text] {
  padding-block: 0;
  padding-inline: 0 !important;
}

.d-flex-content-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-center {
  text-align: center;
}

.reject-message {
  font-size: 14px;
  font-weight: 400;
  color: #000;
}

.modal-action-btn {
  display: flex;
  justify-content: end;
  gap: 10px;
  margin-top: 30px;
}

.user-new-role [role=option] {
  font-size: 12px !important;
}

.mt-20 {
  margin-top: 20px;
}

.ABB_CommonUX_Checkbox__root.ABB_CommonUX_Checkbox__light {
  color: var(--checkbox-description-text-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/new_uesr_request.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AAAE;EACE,qDAAA;EACA,4BAAA;EACA,mBAAA;AAEJ;AADI;EACE,cAAA;AAGN;AADI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAGN;AAFM;EACE,gBAAA;AAIR;AADI;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;AAGN;AAAM;EACE,sBAAA;EACA,2BAAA;AAER;AAAM;EACE,qBAAA;AAER;AAAM;EACE,0BAAA;AAER;AAEI;EACE,qBAAA;AAAN;AAEI;EACE,aAAA;EACA,oBAAA;EACA,gBAAA;AAAN;AAEI;EACE,uBAAA;AAAN;AAGE;EACE,SAAA;AADJ;AAGE;EACE,gBAAA;AADJ;AAGE;EACE,cAAA;EACA,eAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AADJ;AAGE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;AADJ;AAIE;EACE,qBAAA;EACA,2BAAA;EACA,gCAAA;EACA,6BAAA;EACA,4BAAA;AAFJ;;AAKA;EACE,gBAAA;EACA,4BAAA;AAFF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;;AAGA;EACE,kBAAA;AAAF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AACF;;AACA;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;AAEF;;AACE;EACE,0BAAA;AAEJ;;AACA;EACE,gBAAA;AAEF;;AAAA;EACE,wDAAA;AAGF","sourcesContent":[".new-user-request-container {\n  height: 100%;\n  .filter-section {\n    background-color: var(--content-container-background);\n    padding: 10px 10px 20px 10px;\n    border-radius: 10px;\n    .grid-container {\n      padding: 0 5px;\n    }\n    .filter-button {\n      display: inline-flex;\n      align-items: center;\n      gap: 5px;\n      min-width: 100px;\n      border-radius: 20px;\n      padding: 5px;\n      .filter-label {\n        font-weight: 600;\n      }\n    }\n    .filter-label {\n      font-size: 12px;\n      font-weight: 400;\n      font-family: \"ABBVoice-regular\";\n    }\n    .filter-fields {\n      .css-13cymwt-control {\n        width: 100% !important;\n        min-height: 32px !important;\n      }\n      .css-b62m3t-container {\n        width: 90% !important;\n      }\n      [role=\"option\"] {\n        font-size: 12px !important;\n      }\n    }\n\n    .input-width-90 {\n      width: 90% !important;\n    }\n    .apply-button {\n      display: flex;\n      justify-content: end;\n      margin-top: 20px;\n    }\n    .ABB_CommonUX_Input__root > .ABB_CommonUX_Input__inputWrapper {\n      height: 36px !important;\n    }\n  }\n  .gap-20 {\n    gap: 20px;\n  }\n  .mt-20 {\n    margin-top: 20px;\n  }\n  .action-link {\n    color: #2934ff;\n    cursor: pointer;\n    font-family: \"ABBvoice-regular\";\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n  }\n  .d-flex-justify-content-start {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 20px;\n  }\n\n  .css-j87k8z-control {\n    width: 90% !important;\n    min-height: 34px !important;\n    border-color: #dbdbdb !important;\n    border-radius: 4px !important;\n    border-width: 2px !important;\n  }\n}\ninput[type=\"text\"] {\n  padding-block: 0;\n  padding-inline: 0 !important;\n}\n.d-flex-content-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.text-center {\n  text-align: center;\n}\n.reject-message {\n  font-size: 14px;\n  font-weight: 400;\n  color: #000;\n}\n.modal-action-btn {\n  display: flex;\n  justify-content: end;\n  gap: 10px;\n  margin-top: 30px;\n}\n.user-new-role {\n  [role=\"option\"] {\n    font-size: 12px !important;\n  }\n}\n.mt-20 {\n  margin-top: 20px;\n}\n.ABB_CommonUX_Checkbox__root.ABB_CommonUX_Checkbox__light {\n  color: var(--checkbox-description-text-color)!important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
